import React, { Fragment, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import {
  CustomInput,
  Modal,
  ModalBody,
  CardImg,
  Input,
  Label,
  Row,
  Button,
  ButtonGroup,
  Form,
  FormGroup,
  Card,
  CardBody,
  ModalHeader,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import ImageGallery from '../../propinfo/gallery/index';
import IntlMessages from '../../../../../helpers/IntlMessages';

const ContactForm = ({ toggle, visible, item, propertyId, handleSubmit }) => {
  const [contact, setContact] = useState(
    item || {
      groupId: getGroupID(),
      propertyId: propertyId,
      name: '',
      email: '',
      phone: '',
      firstName: '',
      lastName: '',
      membershipId: '',
      salesforceId: '',
      zipCode: '',
      isCompendiumUser: false,
      password: '',
      consent: false,
      creator: 'Admin',
      profile: '',
      membershipCard: '',
    }
  );
  const [fileObj, setFileObj] = useState([]);
  const [isAgree, setAgree] = useState(false);
  const [isCheck, setIsCheck] = useState(false);
  const [files, setFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        if (
          file.name.includes('png') ||
          file.name.includes('jpg') ||
          file.name.includes('jpeg')
        ) {
          const newFileObj = [{
            img: Object.assign(file, {
              preview: URL.createObjectURL(file),
            }),
            tags: [],
            caption: '',
          }];
          setFileObj(newFileObj);
          selectedImage(newFileObj);
        } else {
          togglegallery();
        }
      });
    },
  });
  const [imageType, setImageType] = useState();
  const [galleryVisible, setGalleryVisible] = useState(false);

  const togglegallery = (type) => {
    setIsCheck(false);
    setAgree(false);
    setFileObj([]);
    setImageType(type);
    setGalleryVisible(!galleryVisible);
  };

  const handleCheck = (e) => {
    setContact({ ...contact, consent: e.target.checked });
  };

  const hadleContactEditChange = (e) =>
    setContact({ ...contact, [e.target.name]: e.target.value });

  const handleSave = () => {
    if (contact.consent === 'Yes' || contact.consent === 'No')
      contact.consent = contact?.consent === 'Yes' ? true : false;

    const data = new FormData();
    if (contact.profile && contact.profile.length > 0)
      data.append('files', contact.profile[0].img);

    if (contact.membershipCard && contact.membershipCard.length > 0)
      data.append('files', contact.membershipCard[0].img);
    if (
      contact.profile &&
      contact.profile.length > 0 &&
      contact.membershipCard &&
      contact.membershipCard.length > 0
    )
      data.append('type', 'both');
    else if (contact.profile && contact.profile.length > 0)
      data.append('type', 'profile');
    else if (contact.membershipCard && contact.membershipCard.length > 0)
      data.append('type', 'membershipCard');

    data.append('name', contact?.name);
    data.append('email', contact?.email);
    data.append('channel', contact?.isCompendiumUser ? 'Compendium' : '');
    data.append('phone', contact?.phone);
    data.append('password', contact?.password);
    data.append('membershipId', contact?.membershipId);
    data.append('propertyId', propertyId);
    data.append('groupId', getGroupID());
    data.append('creator', 'Admin');
    handleSubmit(data);
  };

  const selectedImage = (item) => {
    if (imageType === 'profile')
      setContact({
        ...contact,
        profile: item,
      });
    else if (imageType !== 'profile')
      setContact({
        ...contact,
        membershipCard: item,
      });
    //togglegallery();
  };

  const handleUpload = () => {
    if (isAgree && isCheck) togglegallery();
  };

  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
                backdrop="static"
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <Card className="mb-4">
                    <CardBody>
                      <Row className="mt-3">
                        <Colxx xxs="12">
                          <section className="container">
                            <div {...getRootProps({ className: 'dropzone' })}>
                              <input {...getInputProps()} />
                              <div className="dz-default dz-message">
                                <span>
                                  Drop files here to upload, or click to select files. Recommended upload limit of 10mb per file. Supported formats: JPEG, PNG, GIF, WEBP, SVG.
                                </span>
                                <p className="font-weight-medium mb-0 ">
                                  <i className="demo-icon simple-icon-cursor-move"></i>
                                </p>
                              </div>
                            </div>
                            <div
                              className="filepicker dropzone-gallery dz-clickable dz-started"
                              style={{ minHeight: '100px', border: '0px' }}
                            >
                              {imageType === 'profile' &&
                                contact.profile !== undefined &&
                                contact?.profile !== null &&
                                contact.profile.length > 0 &&
                                contact.profile[0]?.img && (
                                  <div
                                    className="dz-preview dz-file-preview mb-3"
                                    style={{ height: '100px' }}
                                  >
                                    <div className="row">
                                      <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                                        <div>
                                          {' '}
                                          <span data-dz-name>
                                            {contact.profile[0]?.img.name}
                                          </span>{' '}
                                        </div>
                                        <div
                                          className="text-primary text-extra-small"
                                          data-dz-size
                                        >
                                          {contact.profile[0]?.img.size}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              {imageType !== 'profile' &&
                                contact?.membershipCard &&
                                contact?.membershipCard !== null &&
                                contact.membershipCard.length > 0 &&
                                contact.membershipCard[0]?.img && (
                                  <div
                                    className="dz-preview dz-file-preview mb-3"
                                    style={{ height: '100px' }}
                                  >
                                    <div className="row">
                                      <div className="pl-3 pt-2 pr-2 pb-1 w-70 dz-details position-relative">
                                        <div>
                                          {' '}
                                          <span data-dz-name>
                                            {
                                              contact.membershipCard[0]?.img
                                                .name
                                            }
                                          </span>{' '}
                                        </div>
                                        <div
                                          className="text-primary text-extra-small"
                                          data-dz-size
                                        >
                                          {contact.membershipCard[0]?.img.size}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          </section>
                          <div
                            className="d-flex text-center ml-0 font-weight-bold mt-1 mb-2"
                            style={{ justifyContent: 'center' }}
                          >
                            <CustomInput
                              type="checkbox"
                              id="isAgree"
                              onChange={(e) => {
                                console.log(e);
                                setAgree(!isAgree);
                              }}
                            >
                              <span
                                className="mt-1"
                                style={{ verticalAlign: 'sub' }}
                              >
                                I have copyright or permissions to use this
                                document.
                              </span>
                            </CustomInput>
                          </div>
                          <div
                            className="d-flex text-center ml-0 font-weight-bold mt-1 mb-2"
                            style={{ justifyContent: 'center' }}
                          >
                            <CustomInput
                              type="checkbox"
                              id="isCheck"
                              onChange={(e) => {
                                console.log(e);
                                setIsCheck(!isCheck);
                              }}
                            >
                              <span
                                className="mt-1"
                                style={{ verticalAlign: 'sub' }}
                              >
                                This document does not contain any personally
                                identifiable information.
                              </span>
                            </CustomInput>
                          </div>
                          <div
                            className="mt-2 d-flex"
                            style={{ justifyContent: 'center' }}
                          >
                            <Button
                              color="primary"
                              onClick={handleUpload}
                              className={`btn-multiple-state text-white`}
                            >
                              <span className="spinner d-inline-block">
                                <span className="bounce1" />
                                <span className="bounce2" />
                                <span className="bounce3" />
                              </span>
                              <span className="icon success">
                                <i className="simple-icon-check" />
                              </span>
                              <span className="icon fail">
                                <i className="simple-icon-exclamation" />
                              </span>
                              <span className="label">Save</span>
                            </Button>
                          </div>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Fragment>
      <Modal toggle={toggle} isOpen={visible} wrapClassName="modal-right" backdrop="static">
        <ModalHeader toggle={toggle}>Contact</ModalHeader>
        <ModalBody className="p-3">
          <Row>
            <Colxx xxs="12" className="mb-2">
              <Form className="text-left">
                <FormGroup className="mb-2">
                  <Label>Contact Name</Label>
                  <Input
                    type="text"
                    name="name"
                    onChange={hadleContactEditChange}
                    value={contact?.name}
                    placeholder="Name"
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Label>Contact Phone</Label>
                  <Input
                    type="text"
                    name="phone"
                    onChange={hadleContactEditChange}
                    value={contact?.phone}
                    placeholder="Phone"
                  />
                </FormGroup>
                <FormGroup className="mb-2">
                  <Label>Contact Email</Label>
                  <Input
                    type="text"
                    name="email"
                    onChange={hadleContactEditChange}
                    value={contact?.email}
                    placeholder="Mail"
                  />
                </FormGroup>

                {contact?.contactId === undefined && (
                  <FormGroup className="mb-2">
                    <Label>Is a Member</Label>
                    <CustomInput
                      type="checkbox"
                      id="checkAll"
                      checked={contact?.isCompendiumUser}
                      onChange={(e) =>
                        setContact({
                          ...contact,
                          isCompendiumUser: e.target.checked,
                          channel: e.target.checked ? 'Compendium' : '',
                        })
                      }
                    />
                  </FormGroup>
                )}
                {contact?.channel === 'Compendium' && (
                  <FormGroup className="mb-2">
                    <Label>Membership Id</Label>
                    <Input
                      type="text"
                      name="membershipId"
                      onChange={hadleContactEditChange}
                      value={contact?.membershipId}
                      placeholder="Membership Id"
                    />
                  </FormGroup>
                )}
                {contact?.channel === 'Compendium' &&
                  contact?.contactId === undefined && (
                    <FormGroup className="mb-2">
                      <Label>Contact Password</Label>
                      <Input
                        type="password"
                        name="password"
                        onChange={hadleContactEditChange}
                        value={contact?.password}
                        placeholder="Password"
                      />
                    </FormGroup>
                  )}
                {contact?.channel !== 'Compendium' && (
                  <FormGroup className="mb-2">
                    <Label>    <IntlMessages id='dashboards.marketingconsent' /></Label>
                    <CustomInput
                      type="checkbox"
                      id={contact.propertyId}
                      defaultChecked={
                        contact.consent == 'No' || contact.consent == false
                          ? false
                          : true
                      }
                      onChange={(e) => handleCheck(e)}
                    ></CustomInput>
                  </FormGroup>
                )}
              </Form>
            </Colxx>
            {contact?.channel === 'Compendium' && (
              <Colxx xxs="12" className="mb-2">
                <h6>Profile Picture</h6>
                {contact?.profile && contact?.profile !== '' ? (
                  <CardImg
                    top
                    src={Array.isArray(contact?.profile) && contact?.profile[0]?.img?.preview ? contact?.profile[0]?.img?.preview : `data:jpeg;base64,${contact?.profile}`}
                    alt=""
                    className="mb-2 img-thumbnail border-0 rounded-circle list-thumbnail"
                  />
                ) : (
                  <div className="contact-round-name"><i className="simple-icon-user"></i></div>
                )}
                <div className="mb-1">
                  <Button
                    color="success"
                    size="xs"
                    className="mt-1"
                    onClick={() => togglegallery('profile')}
                  >
                    Browse profile picture
                  </Button>
                </div>
              </Colxx>
            )}
            {contact?.channel === 'Compendium' && (
              <Colxx xxs="12" className="mb-2">
                <h6>Membership Card</h6>
                {contact?.membershipCard != null &&
                  contact?.membershipCard !== '' && (
                    <CardImg
                      top
                      src={`data:jpeg;base64,${contact?.membershipCard}`}
                      alt=""
                      className="img-thumbnail border-0 list-thumbnail"
                    />
                  )}
                <div className="mb-1">
                  <Button
                    color="success"
                    size="xs"
                    className="mb-2"
                    onClick={() => togglegallery('membershipCard')}
                  >
                    Browse membership card
                  </Button>
                </div>
              </Colxx>
            )}
          </Row>
          <Separator />
          <Colxx md="12" className="d-flex justify-content-center">
            <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
              <Button color="primary" size="sm" onClick={handleSave}>
                <IntlMessages id='dashboards.save' />
              </Button>
              <Button size="sm" color="dark" outline onClick={toggle}>
                <IntlMessages id='pages.cancel' />
              </Button>
            </ButtonGroup>
          </Colxx>
        </ModalBody>
      </Modal>
      {ImageGalleryButton()}
    </Fragment>
  );
};

export default ContactForm;
